"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M23 12.0008c0 3.0376-1.2312 5.7876-3.2218 7.7782l-1.4142-1.4142C19.9926 16.7361 21 14.4861 21 12.0008s-1.0074-4.7352-2.636-6.364l1.4142-1.4141C21.7688 6.2133 23 8.9633 23 12.0008z"
  }), _react.default.createElement("path", {
    d: "M19.5 12.0008c0 2.0711-.8395 3.9461-2.1967 5.3033l-1.4142-1.4142c.9953-.9953 1.6109-2.3703 1.6109-3.8891 0-1.5188-.6156-2.8938-1.6109-3.889l1.4142-1.4143C18.6605 8.0548 19.5 9.9298 19.5 12.0008zM6.6967 17.3041l1.4142-1.4142C7.1156 14.8946 6.5 13.5196 6.5 12.0008c0-1.5188.6156-2.8938 1.611-3.889L6.6966 6.6974C5.3395 8.0548 4.5 9.9298 4.5 12.0008c0 2.0711.8395 3.9461 2.1967 5.3033z"
  }), _react.default.createElement("path", {
    d: "M3 12.0008c0-2.4853 1.0074-4.7352 2.636-6.364l-1.4142-1.414C2.2312 6.2133 1 8.9633 1 12.0008c0 3.0376 1.2312 5.7876 3.2218 7.7782l1.4142-1.4142C4.0074 16.7361 3 14.4861 3 12.0008z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6c-1.6569 0-3 1.3431-3 3v4c0 1.3018.8291 2.4099 1.9881 2.8251v2.1723H9v2h6v-2h-2.0119v-2.1639C14.1595 15.425 15 14.3107 15 13V9c0-1.6569-1.3431-3-3-3zm-1 3c0-.5523.4477-1 1-1s1 .4477 1 1v4c0 .5523-.4477 1-1 1s-1-.4477-1-1V9z"
  })];
};

exports.default = _default;